export default __webpack_public_path__ + "static/media/commercial3.dd347241.PNG";